export default __webpack_public_path__ + "static/media/gallery_04.0b587ca6.jpg";